import axios from "axios";

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BETTEREZ_BASE_URL + "/sales/",
  headers: {
    "x-api-key": process.env.VUE_APP_BETTEREZ_X_API_KEY,
  },
});
export default {
  createCart(cartPostBody) {
    return HTTP.post("cart", cartPostBody);
  },
  createItemCart(cartPostBody, cartId) {
    return HTTP.post("cart/" + cartId + "/items", cartPostBody);
  },
  removeFromCart(cartId, operationId) {
    return HTTP.delete("cart/" + cartId + "/items", {
      params: {
        operationId: operationId,
        providerId: process.env.VUE_APP_BETTEREZ_PROVIDER_ID
      }
    });
  },
  getCart(cartId) {
    return HTTP.get("cart/" + cartId);
  },
  applyPromoCode(cartId, promoCode) {
    return HTTP.post("cart/" + cartId + "/promos?promoCode=" + promoCode, {
      params: {
        promoCode: promoCode,
        channel: "websales",
        providerId: process.env.VUE_APP_BETTEREZ_PROVIDER_ID
      }
    });
  },
  createOrder(orderPostBody) {
    return HTTP.post("order", orderPostBody);
  },
  checkGC(cartId, gcNumber) {
    return HTTP.get("gift-certificates/" + gcNumber, {
      params: {
        cartId: cartId,
      },
    });
  },
  checkVC(cartId, internalId) {
    return HTTP.get("vouchers/" + internalId, {
      params: {
        cartId: cartId,
      },
    });
  },
  getCustomFields() {
    return HTTP.get("custom-fields", {
      // params: {
      //   providerId: process.env.VUE_APP_BETTEREZ_PROVIDER_ID,
      // },
    });
  },
};
